import React from "react";
import { Price } from "web/react/emo/price";
import { Text } from "web/react/emo/text";
import { gettext } from "web/script/modules/django-i18n";
import {
    DesignerSerializer,
    ProductBuyOptionsSerializer,
    ProductSerializer,
} from "web/types/serializers";
import * as styles from "./product-card-horizontal.css";

export type ProductCardHorizontalDetailsProps = {
    product: ProductSerializer;
    designer: DesignerSerializer;
    buyOption: ProductBuyOptionsSerializer;
    ViewProductDetailsContainer: React.ComponentType<{ children: React.ReactNode }>;
};

export const ProductCardHorizontalDetails = ({
    product,
    designer,
    buyOption,
    ViewProductDetailsContainer,
}: ProductCardHorizontalDetailsProps): JSX.Element => {
    const { price, sale_price } = buyOption;
    const { short_description: shortDescription } = product;
    const { name } = designer;

    return (
        <div className={styles.content}>
            <div className={styles.productInformation} data-testid="product-information">
                <Price
                    size="sm"
                    style="primary"
                    fullPrice={price}
                    salePrice={sale_price}
                    inStock={buyOption?.in_stock ?? false}
                />
                <div>
                    <Text textStyle={"body-s-bold"} color="secondary" upperCase>
                        {name}
                    </Text>
                    <Text textStyle={"body-s"} color="secondary">
                        {shortDescription}
                    </Text>
                </div>
            </div>
            <ViewProductDetailsContainer>
                <Text color="primary" textStyle={"body-s"} underline>
                    {gettext("product.view_product_details")}
                </Text>
            </ViewProductDetailsContainer>
        </div>
    );
};
